import { DynamicAnimatedWave } from "@/components/shared/DynamicAnimatedWave";

interface VoiceRecordingWaveFormProps {
  isRecording: boolean;
  amplitude: number;
}

export function VoiceRecordingWaveForm({
  isRecording,
  amplitude,
}: VoiceRecordingWaveFormProps) {
  if (!isRecording) {
    return null;
  }

  return (
    <div className="relative flex h-[48px] w-full flex-col items-center justify-center">
      <DynamicAnimatedWave amplitude={amplitude} />
      <div className="absolute -bottom-1 animate-pulse text-xs opacity-50">
        Listening...
      </div>
    </div>
  );
}
